module.exports = __webpack_public_path__ + "img/18.b88ba210.png";